import { Middleware } from '@nuxt/types'

const mobileMenu: Middleware = ({ store }) => {
  if (store.state.menuOpen) {
    store.commit('SET_MENU', false)
  }
}

export default mobileMenu
